import { useState } from 'react';
import { Paper, Collapse, Typography, Box, Grid, TextField, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Component styles
const styles = {
  paper: {
    marginBottom: '1rem' // Bottom margin for the paper component
  },
  header: {
    padding: '1rem',
    display: 'flex',
    justifyContent: 'around' // Header layout styling
  },
  title: {
    flex: 1 // Title takes available space
  },
  container: {
    padding: '1rem',
    paddingTop: '0' // Container padding with no top padding
  },
  inputWrapper: {
    paddingX: '0.5rem' // Horizontal padding for input wrappers
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-around' // Action buttons layout
  }
}

// Filter component for visits with collapsible interface
const VisitsFilter = props => {
  // State to manage the collapse/open state of the filter
  const [open, setOpen] = useState(false);

  // Toggle function for expanding/collapsing the filter
  const toggleOpen = () => setOpen(!open);

  return (
    <Paper elevation={3} sx={styles.paper}>
      {/* Clickable header that toggles the filter expansion */}
      <Box sx={styles.header} onClick={toggleOpen}>
        <Typography variant="h6" fontWeight="bold" sx={styles.title}>Filtro</Typography>
        <ArrowDropDownIcon /> {/* Dropdown indicator icon */}
      </Box>
      
      {/* Collapsible content area */}
      <Collapse in={open}>
        <Grid container component="form" sx={styles.container} onSubmit={props.onSubmit}>
          {/* Identification filter input */}
          <Grid item xs={12} sx={styles.inputWrapper}>
            <TextField 
              label="Identificación" 
              name="identification" 
              value={props.identification} 
              onChange={props.onChange} 
            />
          </Grid>

          {/* Candidate name filter input */}
          <Grid item xs={12} sx={styles.inputWrapper}>
            <TextField 
              label="Nombre Candidato" 
              name="name" 
              value={props.name} 
              onChange={props.onChange} 
            />
          </Grid>
          
          {/* Action buttons */}
          <Grid item xs={12} sx={styles.actions}>
            <Button type="submit">Buscar</Button> {/* Submit button to apply filters */}
            <Button onClick={props.onClear} color="neutral">Limpiar</Button> {/* Clear filters button */}
          </Grid>
        </Grid>
      </Collapse>
    </Paper>
  );
}

export default VisitsFilter;